const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Thrilling%20car%20chase%20action%20movie%20scene%20on%20highway%20at%20sunset%2C%20dramatic%20lighting%2C%20fast%20motion%20blur%2C%20cinematic%20photography%2C%20warm%20golden%20hour%20tones%2C%20intense%20atmosphere%2C%20professional%20film%20look%2C%20no%20text&width=640&height=360&seq=media-01&orientation=landscape',
    title: '《极速追击》全新上线',
    tag: '动作',
    duration: '128分钟',
    heat: '9.6',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20royal%20court%20ceremony%2C%20elaborate%20costumes%2C%20warm%20palace%20interior%20lighting%2C%20rich%20red%20and%20gold%20color%20scheme%2C%20cinematic%20wide%20composition%2C%20elegant%20traditional%20aesthetic%2C%20no%20text&width=640&height=360&seq=media-02&orientation=landscape',
    title: '《长安风云录》热播中',
    tag: '古装',
    duration: '40集',
    heat: '9.3',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Funny%20comedy%20TV%20series%20scene%20with%20group%20of%20friends%20laughing%20in%20modern%20apartment%2C%20bright%20natural%20lighting%2C%20warm%20and%20cozy%20atmosphere%2C%20sitcom%20style%20cinematography%2C%20vibrant%20color%20palette%2C%20no%20text&width=640&height=360&seq=media-03&orientation=landscape',
    title: '《欢乐一家人》第二季',
    tag: '喜剧',
    duration: '36集',
    heat: '8.9',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Supernatural%20horror%20movie%20scene%20in%20dark%20haunted%20house%2C%20eerie%20atmosphere%2C%20dim%20candlelight%2C%20cinematic%20horror%20photography%2C%20cold%20blue%20moonlight%20contrasting%20with%20warm%20candle%20glow%2C%20suspenseful%20composition%2C%20no%20text&width=640&height=360&seq=media-04&orientation=landscape',
    title: '《幽宅惊魂》恐怖来袭',
    tag: '恐怖',
    duration: '96分钟',
    heat: '8.7',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            精彩推荐
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 cursor-pointer">
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-video object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-background-950/70 text-white text-xs">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-white text-xs">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1.5 mt-2">
                  <span className="text-accent-500 text-xs font-semibold">{item.heat}</span>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-foreground-400 text-xs ml-auto">
                    <i className="ri-eye-line mr-0.5"></i>2.3w
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}